// extracted by mini-css-extract-plugin
export default {"positive":"Dashboard_positive__GQniJ","negative":"Dashboard_negative__Er7Uu","depositContext":"Dashboard_depositContext__SazRZ","addMargin":"Dashboard_addMargin__Cy9sI"};